import { MapPin, AlertTriangle, Users, Share2, Heart, PawPrint } from "lucide-react";
import shareCardBg from "@/assets/share-card-bg.png";
import { GraphicBackground } from "./GraphicBackground";

interface Props {
  backgroundDataUrl?: string;
}

export const InstagramPost2Bento = ({ backgroundDataUrl }: Props) => {
  const bgImage = backgroundDataUrl || shareCardBg;
  
  return (
    <GraphicBackground
      width={1080}
      height={1080}
      bgImage={bgImage}
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {/* Main content */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "80px 60px",
          height: "100%",
          boxSizing: "border-box",
        }}
      >
        {/* Header */}
        <div style={{ textAlign: "center" }}>
          <p
            style={{
              fontSize: "28px",
              fontWeight: 600,
              color: "#4E8A6E",
              margin: "0 0 8px 0",
              letterSpacing: "3px",
              textTransform: "uppercase",
            }}
          >
            Wszystko w jednym miejscu
          </p>
          <h1
            style={{
              fontSize: "72px",
              fontWeight: 800,
              color: "#2D5A3D",
              margin: "0",
              lineHeight: 1.1,
            }}
          >
            6 powodów,<br />by sprawdzić 👇
          </h1>
        </div>

        {/* Bento Grid */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gridTemplateRows: "1fr 1fr 1fr",
            gap: "16px",
            width: "100%",
            maxWidth: "860px",
          }}
        >
          {/* Large card - spans 2 rows */}
          <div
            style={{
              background: "linear-gradient(135deg, #4E8A6E 0%, #3D7A5E 100%)",
              borderRadius: "28px",
              padding: "32px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              gridRow: "span 2",
              boxShadow: "0 12px 40px rgba(78, 138, 110, 0.3)",
            }}
          >
            <MapPin style={{ width: "48px", height: "48px", color: "#FFFFFF" }} />
            <div>
              <h3 style={{ fontSize: "36px", fontWeight: 800, color: "#FFFFFF", margin: 0 }}>
                Mapa<br />Schronisk
              </h3>
              <p style={{ fontSize: "20px", color: "rgba(255,255,255,0.85)", margin: "8px 0 0", fontWeight: 500 }}>
                Znajdź najbliższe jednym kliknięciem
              </p>
            </div>
          </div>

          {/* Top right card */}
          <div
            style={{
              background: "#FFF",
              borderRadius: "28px",
              padding: "28px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              boxShadow: "0 8px 32px rgba(0,0,0,0.08)",
              border: "3px solid #F97316",
            }}
          >
            <AlertTriangle style={{ width: "40px", height: "40px", color: "#F97316" }} />
            <div>
              <h3 style={{ fontSize: "26px", fontWeight: 800, color: "#2D5A3D", margin: 0 }}>
                Pilne potrzeby
              </h3>
              <p style={{ fontSize: "16px", color: "#6B8A7A", margin: "4px 0 0", fontWeight: 500 }}>
                Wyróżnione na górze listy
              </p>
            </div>
          </div>

          {/* Middle right card */}
          <div
            style={{
              background: "linear-gradient(135deg, #8B5CF6 0%, #7C3AED 100%)",
              borderRadius: "28px",
              padding: "28px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              boxShadow: "0 8px 32px rgba(139, 92, 246, 0.25)",
            }}
          >
            <Users style={{ width: "40px", height: "40px", color: "#FFFFFF" }} />
            <div>
              <h3 style={{ fontSize: "26px", fontWeight: 800, color: "#FFFFFF", margin: 0 }}>
                Wolontariat
              </h3>
              <p style={{ fontSize: "16px", color: "rgba(255,255,255,0.85)", margin: "4px 0 0", fontWeight: 500 }}>
                Spacery i pomoc na miejscu
              </p>
            </div>
          </div>

          {/* Bottom left card */}
          <div
            style={{
              background: "#FFF",
              borderRadius: "28px",
              padding: "28px",
              display: "flex",
              alignItems: "center",
              gap: "20px",
              boxShadow: "0 8px 32px rgba(0,0,0,0.08)",
            }}
          >
            <div
              style={{
                width: "64px",
                height: "64px",
                background: "#FDF2F8",
                borderRadius: "16px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              <Share2 style={{ width: "32px", height: "32px", color: "#EC4899" }} />
            </div>
            <div>
              <h3 style={{ fontSize: "24px", fontWeight: 800, color: "#2D5A3D", margin: 0 }}>
                Gotowe grafiki
              </h3>
              <p style={{ fontSize: "15px", color: "#6B8A7A", margin: "2px 0 0", fontWeight: 500 }}>
                Do udostępnienia w social media
              </p>
            </div>
          </div>

          {/* Bottom right card */}
          <div
            style={{
              background: "linear-gradient(135deg, #FBBF24 0%, #F59E0B 100%)",
              borderRadius: "28px",
              padding: "28px",
              display: "flex",
              alignItems: "center",
              gap: "20px",
              boxShadow: "0 8px 32px rgba(251, 191, 36, 0.3)",
            }}
          >
            <Heart style={{ width: "48px", height: "48px", color: "#FFFFFF", fill: "#FFFFFF" }} />
            <div>
              <h3 style={{ fontSize: "24px", fontWeight: 800, color: "#FFFFFF", margin: 0 }}>
                Pomóż dziś!
              </h3>
              <p style={{ fontSize: "15px", color: "rgba(255,255,255,0.9)", margin: "2px 0 0", fontWeight: 600 }}>
                Każdy gest się liczy 💛
              </p>
            </div>
          </div>
        </div>

        {/* Logo with brand name */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "16px",
          }}
        >
          <div
            style={{
              background: "#4E8A6E",
              borderRadius: "14px",
              width: "56px",
              height: "56px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            }}
          >
            <PawPrint style={{ width: "32px", height: "32px", color: "#FFFFFF" }} />
          </div>
          <span style={{ fontSize: "36px", fontWeight: 800, color: "#2D5A3D" }}>
            GdzieSchronisko
          </span>
        </div>
      </div>
    </GraphicBackground>
  );
};

